import {ChangeDetectorRef, Component, forwardRef, Input, Optional} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";

@Component({
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FUICheckboxControlComponent),
        multi: true
    }],
    selector: "fui-checkbox-control",
    templateUrl: "./checkbox-control.component.html",
})
export class FUICheckboxControlComponent extends FUIAbstractControl {
    @Input() allowLabelMarkup: boolean = false;
    @Input() public readOnlyNotDisabled: boolean;

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext){
        super(changeDetectorRef);
    }
}
